import React, { Component } from 'react';
class CustomToggler extends Component {
	state = {};
	render() {
		return (
			<>
				<label className='custom-checkbox'>
					<input
						type='checkbox'
						defaultChecked={this.props.value}
						disabled={this.props.isDisabled}
						onChange={e => {
							this.props.onChange({
								target: { value: e.target.checked },
							});
						}}
						name='checkbox'
					/>
					<div className='custom-checkbox-cont'>
						<div className='handle'></div>
					</div>
				</label>
			</>
		);
	}
}

export default CustomToggler;
